module.exports = __webpack_public_path__ + "img/kr.bfd22d0a.svg";